<template>
    <div>
        <div class="row mt-3 mb-2">
            <div class="col-sm-12 col-md-6">
                <h4 class="mt-1">
                    <span
                        @click="hasHistory() ? $router.go(-1) : $router.push('/')"
                        class="button-come-back mr-2"><i class="fas fa-angle-left"></i>
                    </span> Система мотивации B2B менеджеров. Выгрузки
                </h4>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
                <b-form-group
                    class="mb-0 mr-3"
                >
                    <b-form-row
                        class="mb-2"
                    >
                        <b-form-group
                            description="Первый месяц"
                            class="mb-0 col-sm-12 col-md-4"
                        >
                            <b-form-select v-model="selectedStartMonth" :options="monthRange" :disabled="loading"></b-form-select>
                        </b-form-group>
                        <b-form-group
                            description="Последний месяц"
                            class="mb-0 col-sm-12 col-md-4"
                        >
                            <b-form-select v-model="selectedEndMonth" :options="monthRange" :disabled="loading"></b-form-select>
                        </b-form-group>
                        <b-form-group
                            description="Выберите группу сотрудников"
                            class="mb-0 col-sm-12 col-md-4"
                        >
                            <b-form-select v-model="userFilterByOtdel" :options="optionsOfOtdel" :disabled="loading"></b-form-select>
                        </b-form-group>
                    </b-form-row>
                </b-form-group>
            </div>
        </div>
        <div class="px-0 mb-4 text-right">
            <b-form-group>
                <b-form-radio-group
                    id="active-prop-selector"
                    v-model="selectedPropName"
                    :options="propOptions()"
                    name="active-prop-selector"
                    :disabled="loading"
                ></b-form-radio-group>
            </b-form-group>
        </div>
        <tsoft-wrapper :loading="loading">
            <div class="d-block d-block-overflow mb-2 pb-4" v-if="visibleUsersData.length > 0">
                <b-card-group style="flex-wrap: nowrap;">
                    <b-card
                        :header="`${item.name} г.`"
                        header-tag="header"
                        class="month-card-size"
                        v-for="(item, index) in visibleUsersData" :key="index"
                    >
                        <b-card-text>
                            <table class="table-of-users">
                                <tr v-for="(manager, man_index) in item.data.items" :key="man_index">
                                    <td class="text-muted small">{{ manager.user_name }}</td>
                                    <td>{{ manager[selectedPropName] | toShortCurrency }}&nbsp;р.</td>
                                </tr>
                            </table>
                        </b-card-text>

                        <template #footer>
                            <small class="text-muted">
                                <div class="text-center mb-2"><strong>Итоги за {{item.name}} г.</strong></div>
                                <table class="table-all-inline">
                                    <template v-for="(oneSum, sums_index) in sumsByCardIndex(index)">
                                        <tr v-if="selectedPropName === sums_index"
                                            :key="sums_index">
                                            <td>{{ propNames[selectedPropName].name }}:</td>
                                            <td>{{ oneSum| toShortCurrency }}&nbsp;р.</td>
                                        </tr>
                                        <tr v-if="selectedPropName === sums_index && canCountPercents(propNames[selectedPropName].name)">
                                            <td>Реализация<br>по всем из<br>фильтра:</td>
                                            <td>{{ (oneSum * 10)| toShortCurrency }}&nbsp;р.</td>
                                        </tr>
                                    </template>
                                </table>
                            </small>
                        </template>
                    </b-card>
                </b-card-group>
<!--                <div class="text-right font-italic text-muted mt-3">Суммы в карточках указаны без НДС</div>-->
            </div>
            <div class="d-block my-4" v-else-if="!loading">
                Не правильно выбран период или данные отсутствуют.
            </div>
        </tsoft-wrapper>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {
        API_GET_MOTIVATION_REPORT
    } from "../constants"

    import {
        motivationWorkWithDates
    } from "../mixins/motivation/motivationHelpers"
    import Table from "../components/tables/Table";

    export default {
        components: {
            Table
        },
        mixins: [
            motivationWorkWithDates
        ],
        data() {
            return {
                additionalGetParameter: '',
                componentRefreshKey: 0,
                loading: false,
                selectedStartMonth: null,
                selectedEndMonth: null,
                visibleUsersData: [],
                scoredMotivation: [],
                userFilterByOtdel: 'all',
                optionsOfOtdel: [
                    { value: 'all', text: 'Все сотрудники' },
                    { value: 'suppliers', text: 'Все менеджеры поставок' },
                    { value: 'heads', text: 'Руководство компании' },
                    { value: 'sellers', text: 'Отдел продаж' },
                    { value: 'to_department', text: 'Отдел ТО' },
                    { value: 'ved_department', text: 'Отдел логистики' },
                ],
                selectedPropName: 'user_sales_bonus',
                propNames: {
                    user_sales_bonus: {
                        name: "10% продажа услуг"
                    },
                    user_partner_bonus: {
                        name: "3% подключение партнера"
                    },
                    user_escort_bonus: {
                        name: "1% сопровождение"
                    },
                    user_speed_bonus: {
                        name: "Скорость"
                    },
                    user_stavki_bonus: {
                        name: "Котировка ставок"
                    },
                    user_hand_bonus: {
                        name: "Дополнительные бонусы"
                    },
                    user_fines: {
                        name: "Штраф"
                    },
                    user_results: {
                        name: "Итого"
                    },
                }
            }
        },
        watch: {
            scoredMotivation: {
                handler(scoredMotivation) {
                    this.formatData()
                },
                deep: true,
            },
            selectedStartMonth() {
                this.userFilterByOtdel = 'all'
                this.getMotivationReport()
            },
            selectedEndMonth() {
                this.userFilterByOtdel = 'all'
                this.getMotivationReport()
            },
            userFilterByOtdel: {
                handler(filterType) {
                    if (this.visibleUsersData) {
                        this.filteringDataByGroupFilter(filterType)
                    }
                },
            },
            selectedPropName() {
                this.sortData()
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"])
        },
        created() {
        },
        mounted() {
            this.getMotivationReport()
        },
        methods: {
            getMotivationReport() {
                if (!this.loading) {
                    this.loading = true
                    this.scoredMotivation = []

                    api.call('get', API_GET_MOTIVATION_REPORT + `?period_start=${this.selectedStartMonth}&period_end=${this.selectedEndMonth}`).then((response) => {
                        this.scoredMotivation = response.data
                        this.loading = false
                    })
                }
            },
            sumsByCardIndex(index) {
                let cardSums = {
                    user_sales_bonus: 0,
                    user_escort_bonus: 0,
                    user_partner_bonus: 0,
                    user_speed_bonus: 0,
                    user_stavki_bonus: 0,
                    user_hand_bonus: 0,
                    user_fines: 0,
                    user_results: 0,
                }

                this.visibleUsersData[index]['data']['items'].forEach((manager, index) => {
                    for (var prop in cardSums) {
                        cardSums[prop] += manager[prop]
                    }
                })

                return cardSums
            },
            formatData() {
                this.visibleUsersData = JSON.parse(JSON.stringify(this.scoredMotivation))
                this.sortData()
            },
            sortData() {
                this.visibleUsersData.forEach((item) => {
                    item.data.items.sort((a, b) => parseInt(b[this.selectedPropName]) - parseInt(a[this.selectedPropName]))
                })
            },
            filteringDataByGroupFilter(filterType){
                this.formatData()
                this.visibleUsersData.forEach((dataBlock, index) => {
                    this.visibleUsersData[index].data.items = dataBlock.data.items.filter(item => {
                        if (filterType == 'sellers') {
                            return (item.user_roles.includes("sales-manager") || item.user_roles.includes("sales-head-manager"))
                        } else if (filterType == 'suppliers') {
                            return (!item.user_roles.includes("sales-manager") && !item.user_roles.includes("sales-head-manager"))
                        } else if (filterType == 'to_department') {
                            return (item.user_roles.includes("TO-manager") || item.user_roles.includes("TO-head-manager"))
                        } else if (filterType == 'ved_department') {
                            return (item.user_roles.includes("logistics-manager") || item.user_roles.includes("logistics-head-manager"))
                        } else {
                            return item
                        }
                    })
                })
            },
            propOptions() {
                let propOptions = []

                for (var prop in this.propNames) {
                    propOptions.push({
                        text: this.propNames[prop].name,
                        value: prop
                    })
                }

                return propOptions
            },
            onlyForHeads() {
                if (this.currentUser.role && (this.currentUser.role.includes("administrator") ||
                    this.currentUser.role.includes("head-accountant") ||
                    this.currentUser.role.includes("accountant") ||
                    this.currentUser.role.includes("president"))) {
                    return true
                }
                return false
            },
            onlyForHeadsOfOtdels() {
                if (this.currentUser.role && (this.currentUser.role.includes("TO-head-manager") ||
                    this.currentUser.role.includes("logistics-head-manager") ||
                    this.currentUser.role.includes("sales-head-manager"))) {
                    return true
                }
                return false
            },
            canCountPercents(value) {
                let testedValue = parseInt(value.replace(/[^\d]/g, ''))

                if (isNaN(testedValue)) {
                    return false
                }

                return true
            },
            hasHistory () {
                return window.history.length > 2
            },
        }
    }
</script>
<style>
    .d-block-overflow {
        width: 100%;
        max-width: 100%;
        overflow-x: auto;
    }
    .month-card-size {
        min-width: 240px;
        max-width: 240px;
    }
    .custom-select {
        line-height: 21px;
        height: 37px;
        border-radius: 5px;
    }
    .table-of-users tr td:first-child {
        width: 60%;
        line-height: 14px;
    }

    .table-all-inline tr td {
        vertical-align: bottom;
        padding-bottom: 0px;
    }
    .table-all-inline tr td:first-child {
        width: 60%;
        text-align: right;
        line-height: 12px;
        padding-bottom: 5px;
        padding-right: 5px;
    }
    .table-all-inline tr td:last-child {
        text-align: left;
        font-size: 0.9rem;
    }
</style>
